



import { Component, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import ProductMigrationState from '@/models/Products/ProductMigrations/ProductMigrationState';

@Component({ name: 'ProductMigrationState', })
export default class extends SaascadaVue {

    @Prop({ required: true })
    state: ProductMigrationState;

    get textColor() {
        var color: string = "grey--text";
        switch (this.state) {
            case ProductMigrationState.Pending:
                color = "warning--text";
                break;
            case ProductMigrationState.InProgress:
                color = "warning--text";
                break;
            case ProductMigrationState.Complete:
                color = "success--text";
                break;
        }
        return color;
    }

}
